import $ from 'jquery';
import config from '../app-config';

function setOffcanvas() {
    const activeClass = 'is-active';

    const offcanvas = $('.js-offcanvas');
    const trigger = $('.js-offcanvas-trigger');
    const menu = $('.sidenav__item');

    let isClicked = false;

    trigger.on('click', function eventOnClick(event) {
        if ($(window).width() < config.breakpoints.medium) {
            event.preventDefault();

            if (!isClicked) {
                $(this).add(offcanvas).addClass(activeClass);
            } else {
                offcanvas.removeClass(activeClass);
                trigger.removeClass(activeClass);
            }

            isClicked = !isClicked;
        }
    });

    menu.on('mouseenter', function eventOnClick() {
        if ($(window).width() >= config.breakpoints.medium) {
            offcanvas.addClass(activeClass);
        }
    });

    menu.on('mouseleave', function eventOnClick() {
        if ($(window).width() >= config.breakpoints.medium) {
            offcanvas.removeClass(activeClass);
        }
    });
}

function init() {
    if ($('.js-offcanvas').length > 0) setOffcanvas();
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/offcanvas.js